var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: "display: flex;width: 780px;" }, [
    _c(
      "div",
      { staticClass: "form-column" },
      [
        _c("el-form", { staticClass: "result-form" }, [
          _c("table", { attrs: { cellpadding: "0", cellspacing: "0" } }, [
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("FileHistory.fileName")))
              ]),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.details.fileName))
                ])
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.SerialNo")))
              ]),
              _c("td", [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.details.fileNo))
                ])
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.BusinessNumber")))
              ]),
              _c("td", [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.details.jobNo))
                ])
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Hbl2")))
              ]),
              _c("td", [
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.resultJson.hbl))
                ])
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Mbl2")))
              ]),
              _c("td", [
                _c(
                  "span",
                  { style: _vm.isDf("billNo", false, "margin-left: 10px;") },
                  [_vm._v(_vm._s(_vm.resultJson.billNo))]
                )
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.SoNo")))
              ]),
              _c("td", [
                _c(
                  "span",
                  { style: _vm.isDf("soNo", false, "margin-left: 10px;") },
                  [_vm._v(_vm._s(_vm.resultJson.soNo))]
                )
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.WarehouseNo")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("warehouseReceiptNo") },
                    [
                      _c("el-input", {
                        attrs: { no: "1" },
                        model: {
                          value: _vm.resultJson.warehouseReceiptNo,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "warehouseReceiptNo", $$v)
                          },
                          expression: "resultJson.warehouseReceiptNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                _vm._v(_vm._s(_vm.$t("Message.Shipper")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("shipperLine1") },
                    [
                      _c("el-input", {
                        attrs: { no: "2" },
                        model: {
                          value: _vm.resultJson.shipperLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "shipperLine1", $$v)
                          },
                          expression: "resultJson.shipperLine1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("blType") },
                      [
                        _c("el-input", {
                          attrs: { no: "3" },
                          on: { change: _vm.mapperBlType },
                          model: {
                            value: _vm.resultJson.blType,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "blType", $$v)
                            },
                            expression: "resultJson.blType"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        attrs: { no: "4" },
                        model: {
                          value: _vm.resultJson.releaseType,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "releaseType", $$v)
                          },
                          expression: "resultJson.releaseType"
                        }
                      },
                      _vm._l(_vm.blModeList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.name, value: item.serialNumber }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("shipperLine2") },
                    [
                      _c("el-input", {
                        attrs: { no: "5" },
                        model: {
                          value: _vm.resultJson.shipperLine2,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "shipperLine2", $$v)
                          },
                          expression: "resultJson.shipperLine2"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.LCL")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("fclOrLcl") },
                      [
                        _c("el-input", {
                          attrs: { readonly: "", no: "6" },
                          on: { change: _vm.mapperLoadType },
                          model: {
                            value: _vm.resultJson.fclOrLcl,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "fclOrLcl", $$v)
                            },
                            expression: "resultJson.fclOrLcl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        attrs: { no: "7", disabled: "" },
                        model: {
                          value: _vm.resultJson.containerLoadType,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "containerLoadType", $$v)
                          },
                          expression: "resultJson.containerLoadType"
                        }
                      },
                      _vm._l(_vm.containerLoadTypes, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("shipperLine3") },
                    [
                      _c("el-input", {
                        attrs: { no: "8" },
                        model: {
                          value: _vm.resultJson.shipperLine3,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "shipperLine3", $$v)
                          },
                          expression: "resultJson.shipperLine3"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ShippingCompany")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("carrier") },
                      [
                        _c("el-input", {
                          attrs: { no: "9" },
                          on: { change: _vm.mapperShipName },
                          model: {
                            value: _vm.resultJson.carrier,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "carrier", $$v)
                            },
                            expression: "resultJson.carrier"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-company-select", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        no: "10",
                        "method-params": {
                          companyLob: "seaExport",
                          seaCmp: true,
                          active: true
                        },
                        "default-value": _vm.resultJson.carrierId || ""
                      },
                      on: {
                        change: function(p) {
                          _vm.resultJson.carrierId = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("shipperLine4") },
                    [
                      _c("el-input", {
                        attrs: { no: "11" },
                        model: {
                          value: _vm.resultJson.shipperLine4,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "shipperLine4", $$v)
                          },
                          expression: "resultJson.shipperLine4"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.vessel")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("vessel") },
                    [
                      _c("el-input", {
                        attrs: { no: "12" },
                        model: {
                          value: _vm.resultJson.vessel,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "vessel", $$v)
                          },
                          expression: "resultJson.vessel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("shipperLine5") },
                    [
                      _c("el-input", {
                        attrs: { no: "13" },
                        model: {
                          value: _vm.resultJson.shipperLine5,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "shipperLine5", $$v)
                          },
                          expression: "resultJson.shipperLine5"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.voyage")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("voyage") },
                    [
                      _c("el-input", {
                        attrs: { no: "14" },
                        model: {
                          value: _vm.resultJson.voyage,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "voyage", $$v)
                          },
                          expression: "resultJson.voyage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("shipperLine6") },
                    [
                      _c("el-input", {
                        attrs: { no: "15" },
                        model: {
                          value: _vm.resultJson.shipperLine6,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "shipperLine6", $$v)
                          },
                          expression: "resultJson.shipperLine6"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("queryJob.dateOfDeparture")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("etd") },
                      [
                        _c("el-input", {
                          attrs: { no: "16" },
                          on: { change: _vm.mapperEtd },
                          model: {
                            value: _vm.resultJson.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "etd", $$v)
                            },
                            expression: "resultJson.etd"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-date-picker", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        no: "17",
                        value: _vm.resultJson.etd,
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      on: { input: _vm.etdChange }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("shipperLine7") },
                    [
                      _c("el-input", {
                        attrs: { no: "18" },
                        model: {
                          value: _vm.resultJson.shipperLine7,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "shipperLine7", $$v)
                          },
                          expression: "resultJson.shipperLine7"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.contactPerson")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("email") },
                    [
                      _c("el-input", {
                        attrs: { no: "19" },
                        model: {
                          value: _vm.resultJson.email,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "email", $$v)
                          },
                          expression: "resultJson.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                _vm._v(_vm._s(_vm.$t("Message.Consignee")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("consigneeLine1") },
                    [
                      _c("el-input", {
                        attrs: { no: "20" },
                        model: {
                          value: _vm.resultJson.consigneeLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "consigneeLine1", $$v)
                          },
                          expression: "resultJson.consigneeLine1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.TransportationClause")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("serviceTerm") },
                      [
                        _c("el-input", {
                          attrs: { no: "21" },
                          on: { change: _vm.mapperFreightTerm },
                          model: {
                            value: _vm.resultJson.serviceTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "serviceTerm", $$v)
                            },
                            expression: "resultJson.serviceTerm"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        no: "22",
                        "select-type":
                          _vm.selectTypeNames.basic_data_ShippingTerm,
                        filterable: "",
                        clearable: false,
                        "default-value": _vm.resultJson.freightTerm
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.resultJson.freightTerm = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("consigneeLine2") },
                    [
                      _c("el-input", {
                        attrs: { no: "23" },
                        model: {
                          value: _vm.resultJson.consigneeLine2,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "consigneeLine2", $$v)
                          },
                          expression: "resultJson.consigneeLine2"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.FreightTerm")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("freightClauseName") },
                      [
                        _c("el-input", {
                          attrs: { no: "24" },
                          on: { change: _vm.mapperPaymentTerm },
                          model: {
                            value: _vm.resultJson.freightClauseName,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "freightClauseName", $$v)
                            },
                            expression: "resultJson.freightClauseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        no: "25",
                        "select-type":
                          _vm.selectTypeNames.basic_data_PaymentTerm,
                        filterable: "",
                        clearable: false,
                        "default-value": _vm.resultJson.paymentTermMBL
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.resultJson.paymentTermMBL = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("consigneeLine3") },
                    [
                      _c("el-input", {
                        attrs: { no: "27" },
                        model: {
                          value: _vm.resultJson.consigneeLine3,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "consigneeLine3", $$v)
                          },
                          expression: "resultJson.consigneeLine3"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ContainerSize")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("containerType") },
                    [
                      _c("el-input", {
                        attrs: { no: "28" },
                        model: {
                          value: _vm.resultJson.containerType,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "containerType", $$v)
                          },
                          expression: "resultJson.containerType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("consigneeLine4") },
                    [
                      _c("el-input", {
                        attrs: { no: "29" },
                        model: {
                          value: _vm.resultJson.consigneeLine4,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "consigneeLine4", $$v)
                          },
                          expression: "resultJson.consigneeLine4"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ContainerAmount")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("containerNo") },
                    [
                      _c("el-input", {
                        attrs: { no: "30" },
                        model: {
                          value: _vm.resultJson.containerNo,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "containerNo", $$v)
                          },
                          expression: "resultJson.containerNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("consigneeLine5") },
                    [
                      _c("el-input", {
                        attrs: { no: "31" },
                        model: {
                          value: _vm.resultJson.consigneeLine5,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "consigneeLine5", $$v)
                          },
                          expression: "resultJson.consigneeLine5"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("consigneeLine6") },
                    [
                      _c("el-input", {
                        attrs: { no: "34" },
                        model: {
                          value: _vm.resultJson.consigneeLine6,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "consigneeLine6", $$v)
                          },
                          expression: "resultJson.consigneeLine6"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("consigneeLine7") },
                    [
                      _c("el-input", {
                        attrs: { no: "36" },
                        model: {
                          value: _vm.resultJson.consigneeLine7,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "consigneeLine7", $$v)
                          },
                          expression: "resultJson.consigneeLine7"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header", attrs: { rowspan: "7" } }, [
                _vm._v(_vm._s(_vm.$t("Message.Notify")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("notifyLine1") },
                    [
                      _c("el-input", {
                        attrs: { no: "37" },
                        model: {
                          value: _vm.resultJson.notifyLine1,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "notifyLine1", $$v)
                          },
                          expression: "resultJson.notifyLine1"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("quantity") },
                    [
                      _c("el-input", {
                        attrs: { no: "38" },
                        model: {
                          value: _vm.resultJson.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "quantity", $$v)
                          },
                          expression: "resultJson.quantity"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("notifyLine2") },
                    [
                      _c("el-input", {
                        attrs: { no: "39" },
                        model: {
                          value: _vm.resultJson.notifyLine2,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "notifyLine2", $$v)
                          },
                          expression: "resultJson.notifyLine2"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Package")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("packageType") },
                      [
                        _c("el-input", {
                          attrs: { no: "40" },
                          on: { change: _vm.mapperPacking },
                          model: {
                            value: _vm.resultJson.packageType,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "packageType", $$v)
                            },
                            expression: "resultJson.packageType"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-packing-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        "default-value": _vm.resultJson.packing,
                        no: "41"
                      },
                      on: {
                        change: function(p) {
                          _vm.resultJson.packing = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("notifyLine3") },
                    [
                      _c("el-input", {
                        attrs: { no: "42" },
                        model: {
                          value: _vm.resultJson.notifyLine3,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "notifyLine3", $$v)
                          },
                          expression: "resultJson.notifyLine3"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("grossWeight") },
                    [
                      _c("el-input", {
                        attrs: { no: "43" },
                        model: {
                          value: _vm.resultJson.grossWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "grossWeight", $$v)
                          },
                          expression: "resultJson.grossWeight"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("notifyLine4") },
                    [
                      _c("el-input", {
                        attrs: { no: "44" },
                        model: {
                          value: _vm.resultJson.notifyLine4,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "notifyLine4", $$v)
                          },
                          expression: "resultJson.notifyLine4"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("measurement") },
                    [
                      _c("el-input", {
                        attrs: { no: "45" },
                        model: {
                          value: _vm.resultJson.measurement,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "measurement", $$v)
                          },
                          expression: "resultJson.measurement"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("notifyLine5") },
                    [
                      _c("el-input", {
                        attrs: { no: "46" },
                        model: {
                          value: _vm.resultJson.notifyLine5,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "notifyLine5", $$v)
                          },
                          expression: "resultJson.notifyLine5"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("notifyLine6") },
                    [
                      _c("el-input", {
                        attrs: { no: "47" },
                        model: {
                          value: _vm.resultJson.notifyLine6,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "notifyLine6", $$v)
                          },
                          expression: "resultJson.notifyLine6"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("notifyLine7") },
                    [
                      _c("el-input", {
                        attrs: { no: "48" },
                        model: {
                          value: _vm.resultJson.notifyLine7,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "notifyLine7", $$v)
                          },
                          expression: "resultJson.notifyLine7"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { attrs: { colspan: "2" } })
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PlaceOfReceipt")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("portOfReceipt") },
                      [
                        _c("el-input", {
                          attrs: { no: "49" },
                          on: {
                            change: function($event) {
                              return _vm.mapperSeaPort(
                                "dispatchingPlaceCode",
                                "portOfReceipt"
                              )
                            }
                          },
                          model: {
                            value: _vm.resultJson.portOfReceipt,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "portOfReceipt", $$v)
                            },
                            expression: "resultJson.portOfReceipt"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        no: "50",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.resultJson.dispatchingPlaceCode,
                        "tag-name": "englishName"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.resultJson.dispatchingPlaceCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.portOfLoading")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("portOfLoading") },
                      [
                        _c("el-input", {
                          attrs: { no: "51" },
                          on: {
                            change: function($event) {
                              return _vm.mapperSeaPort(
                                "loadingPortCode",
                                "portOfLoading"
                              )
                            }
                          },
                          model: {
                            value: _vm.resultJson.portOfLoading,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "portOfLoading", $$v)
                            },
                            expression: "resultJson.portOfLoading"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        no: "52",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.resultJson.loadingPortCode,
                        "tag-name": "englishName"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.resultJson.loadingPortCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("queryJob.dischargingPortCode")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("portOfDischarge") },
                      [
                        _c("el-input", {
                          attrs: { no: "53" },
                          on: {
                            change: function($event) {
                              return _vm.mapperSeaPort(
                                "dischargingPortCode",
                                "portOfDischarge"
                              )
                            }
                          },
                          model: {
                            value: _vm.resultJson.portOfDischarge,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "portOfDischarge", $$v)
                            },
                            expression: "resultJson.portOfDischarge"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        no: "54",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.resultJson.dischargingPortCode
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.resultJson.dischargingPortCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("queryJob.placeOfDelivery")))
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "mapperClass" },
                  [
                    _c(
                      "el-form-item",
                      { class: _vm.getClass("placeOfDelivery") },
                      [
                        _c("el-input", {
                          attrs: { no: "55" },
                          on: {
                            change: function($event) {
                              return _vm.mapperSeaPort(
                                "destinationPortCode",
                                "placeOfDelivery"
                              )
                            }
                          },
                          model: {
                            value: _vm.resultJson.placeOfDelivery,
                            callback: function($$v) {
                              _vm.$set(_vm.resultJson, "placeOfDelivery", $$v)
                            },
                            expression: "resultJson.placeOfDelivery"
                          }
                        })
                      ],
                      1
                    ),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        no: "56",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.resultJson.destinationPortCode
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.resultJson.destinationPortCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Marks")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("marks") },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          resize: "none",
                          rows: 10,
                          no: "57"
                        },
                        model: {
                          value: _vm.resultJson.marks,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "marks", $$v)
                          },
                          expression: "resultJson.marks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Pricing.Goods")))
              ]),
              _c(
                "td",
                [
                  _c(
                    "el-form-item",
                    { class: _vm.getClass("goodsDescription") },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          resize: "none",
                          rows: 10,
                          no: "58"
                        },
                        model: {
                          value: _vm.resultJson.goodsDescription,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "goodsDescription", $$v)
                          },
                          expression: "resultJson.goodsDescription"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("tr", [
              _c(
                "td",
                { attrs: { colspan: "4" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "800px", height: "200px" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.goods.gridOptions,
                      "column-defs": _vm.goodsColumnDefs,
                      "row-data": _vm.goods.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.goods.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("Payment.remarks")))
              ]),
              _c(
                "td",
                { attrs: { colspan: "3" } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "red" },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          resize: "none",
                          rows: 5,
                          no: "59"
                        },
                        model: {
                          value: _vm.resultJson.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.resultJson, "remark", $$v)
                          },
                          expression: "resultJson.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }